import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { VoiceModalShell } from "@/components/voice/VoiceModalShell";
import { UltureAssistantChat } from "./UltureAssistantChat";

/**
 * Pestaña «Asistente» de la ventana del micrófono: el chat de Ulture Assistant
 * embebido en la misma hoja que Tarea por voz y Muestreo.
 */
export function AssistantChatPanel() {
  const { t, i18n } = useTranslation();
  const { company } = useAuth();
  /* Con conversación a la vista, la hoja se estira a pantalla completa en el
     teléfono: 68dvh está bien para la pantalla de bienvenida, pero leer un hilo
     por esa rendija no. Vuelve a su tamaño con «Nueva conversación». */
  const [hasConversation, setHasConversation] = useState(false);
  const handleConversationChange = useCallback((has: boolean) => setHasConversation(has), []);

  return (
    /* `fullscreenable`: el botón de pantalla completa de la cabecera, que solo
       sale en tableta. Va SOLO aquí y no en las otras dos pestañas del
       conmutador: este es el único sitio donde hay un hilo que leer. */
    <VoiceModalShell
      tab="ai"
      expanded={hasConversation}
      fullscreenable
      bodyClassName="p-0 overflow-hidden bg-white min-h-0"
    >
      {/* La hoja lleva alto FIJO (VoiceModalShell, tab="ai"), así que el cuerpo
          flex-1 recibe exactamente el espacio restante; h-full aquí hace que el
          chat lo llene y ancle su composer al fondo, siempre visible. */}
      <div className="h-full flex flex-col min-h-0">
        <UltureAssistantChat
          embedded
          companyId={company?.id}
          t={t}
          lang={i18n.language}
          onConversationChange={handleConversationChange}
        />
      </div>
    </VoiceModalShell>
  );
}
